import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../ampli';
import { IProduct } from '../../../interfaces/Product.interfaces';
import { calculateAnonymousUserPrice } from '../../../utils/calculator/calculatePrice.util';
import { formatPrice } from '../../../utils/formatter/formatPrice.util';

interface PriceScreenSectionProps {
  product: IProduct;
  pageType: 'plp' | 'pdp';
}

export const PriceScreenSection = ({ product, pageType }: PriceScreenSectionProps) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (pageType === 'plp') {
      ampli.마켓매물목록페이지로그인하고할인된회원가격보기버튼클릭({ '매물 코드': product.code });
      ReactGA.event('pvm_click_plp_view_price_after_login', {
        category: product.category,
        action: 'pvm_click_plp_view_price_after_login',
        product_code: product.code,
      });
    } else if (pageType === 'pdp') {
      ampli.마켓매물상세페이지로그인하고할인된회원가격보기버튼클릭({ '매물 코드': product.code });
      ReactGA.event('pvm_click_pdp_view_price_after_login', {
        category: product.category,
        action: 'pvm_click_pdp_view_price_after_login',
        product_code: product.code,
      });
    }

    navigate('/oauth/login');
  };

  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <TitleSection>
        <Title>{'비회원가 '}</Title>
        <RedTitle>{`${formatPrice(calculateAnonymousUserPrice(product.priceDetails))}원`}</RedTitle>
      </TitleSection>

      <Button onClick={handleButtonClick}>
        <ButtonText>{'로그인하고 할인된 회원가격 보기'}</ButtonText>
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: calc(100% + 32px);
  height: calc(100% + 14px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);

  position: absolute;
  left: -16px;
  top: -8px;

  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const RedTitle = styled(Title)`
  color: var(--Light-Scheme-Color-primary-red, #ff3049);
`;

const Button = styled.button`
  display: flex;
  max-height: 40px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const ButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
